import './EditorArea.css';

const EditorArea = ({ children }) => {
  return (
    <div className='editor-area'>
        {children}
    </div>
  )
}

export default EditorArea